import { useTranslation } from "react-i18next";
import { Text } from "@/components/Text";
import { HelpList, HelpRow } from "./HelpRow";
import { searchHelp } from "./helpSearch";
import type { HelpArticle } from "./useHelpArticles";

/** Results for the landing page's search, linking to the matching heading when there is one. */
export function HelpSearchResults({ articles, query }: Readonly<{ articles: HelpArticle[]; query: string }>) {
  const { t } = useTranslation("help");
  const results = searchHelp(articles, query);

  if (results.length === 0) {
    const fallback = articles.filter((a) => a.slug === "concepts" || a.group === "faq");
    return (
      <div className="flex flex-col gap-6">
        <Text role="status">{t("search.noResults", { query })}</Text>
        <HelpList title={t("search.noResultsHint")}>
          {fallback.map((article) => (
            <HelpRow key={article.slug} to={`/help/${article.slug}`} title={article.title} detail={article.summary} />
          ))}
        </HelpList>
      </div>
    );
  }

  return (
    <HelpList title={t("search.results", { count: results.length, query })}>
      {results.map(({ article, section, snippet }) => (
        <HelpRow
          key={article.slug}
          to={section ? `/help/${article.slug}#${section.id}` : `/help/${article.slug}`}
          title={section ? t("search.inSection", { article: article.title, section: section.title }) : article.title}
          detail={snippet}
        />
      ))}
    </HelpList>
  );
}
